module.exports = __webpack_public_path__ + "img/erweima.d9da5a3a.png";